import React, { useState } from 'react';

import {
  firstSignIn, signIn, signUp, confirmUser, 
} from '@services/auth.service';
import { Button, Checkbox } from '@nazka/nazka.mapframe.components';

import { useAuth } from '../AuthProvider/auth-provider.context';

import './login-modal.styl';

function LoginModal() {
  const { logIn } = useAuth();
  const [signUpIsOn, setSignUpIsOn] = useState(false)
  const [confirmIsOn, setConfirmIsOn] = useState(false)
  const [remember, setRemember] = useState(false);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('');
  const [newPasswordRequired, setNewPasswordRequired] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordRepeat, setNewPasswordRepeat] = useState('');
  const [errorToast, setErrorToast] = useState(null)
  const [seconderrorToast, setSecondErrorToast] = useState(null)

  async function confirmLogin() {
    try {
      if (signUpIsOn) {
        const signUpResult = await signUp({ email, password });
        if (signUpResult.UserSub) {
          setConfirmIsOn(true)
        }
      } else {
        const signInResult = await signIn({ email, password });
        if (signInResult.ChallengeName === 'NEW_PASSWORD_REQUIRED') {
          setNewPasswordRequired({ email, oldPassword: password, session: signInResult.Session });
        } else {
          logIn(remember);
        }
      }
    } catch (err) {
      setErrorToast(err.response.data.message)
    }
  }

  async function signUpConfirmUser() {
    // console.log(email, code)
    const confirmUserEmail = await confirmUser({ email, code });
    if (confirmUserEmail.$metadata.httpStatusCode) {
      setConfirmIsOn(false)
      setSignUpIsOn(false)
      setPassword('')
      setEmail('')
    }
  }

  async function firstLogin() {
    try {
      await firstSignIn({ ...newPasswordRequired, password: newPassword });
      logIn();
    } catch (err) {
      setSecondErrorToast(err.response.data.message)
    }
  }

  return (
    <div className="login-modal">
      <div className="login-modal__window">
        {signUpIsOn ? (
          <h2 className="login-modal__window__title">
            Sign Up
          </h2>
        ) : (
          <h2 className="login-modal__window__title">
            {newPasswordRequired ? 'Set password' : 'Login'}
          </h2>
        )}
        {confirmIsOn ? (
          <div className="login-modal__window__form">
            <input
              onChange={e => setEmail(e.target.value)}
              placeholder="Email"
              type="email"
            />
            <input
              value={code}
              onChange={e => setCode(e.target.value)}
              placeholder="Code"
              type="number"
            />
            <p style={{ fontSize: '14px', padding: '0 16px' }}>Please fill in the code you have received on your email</p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                type="submit"
                className="login-modal__window__form__submit"
                onClick={signUpConfirmUser}
              >
                <span> 
                  Confirm
                </span>
              </button>

            </div>
          </div>
        ) : (
          <div className="login-modal__window__form">
            {!newPasswordRequired && (
              <>
                <input
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Email"
                  type="email"
                />
                <input
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Password"
                  type="password"
                />
                <div className="login-modal__window__form__footer">
                  <span className="error">{errorToast}</span>
                  {(signUpIsOn || confirmIsOn) ? (<> </>) : (
                    <Checkbox
                      name="remember-login"
                      text="Remember login"
                      checked={remember}
                      onInputChange={() => setRemember(prevState => !prevState)}
                    />
                  )}
                
                  <div className="login-modal__betaversion">
                    {!newPasswordRequired && (
                    <Button
                      layout="ghost"
                      hover={false}
                      css={{
                        fontSize: '14px',
                        padding: 0,
                        '&:hover': {
                          textDecoration: 'underline',
                        },
                      }}
                      onClick={() => setSignUpIsOn(prevState => !prevState)}
                    >
                      { signUpIsOn ? 'Log in' : 'Sign up here'}
                    </Button>
                    )}
                  </div>
                </div>
                <div className="login-modal__window__submit__button">
                  <button
                    type="submit"
                    className="login-modal__window__form__submit"
                    onClick={confirmLogin}
                  >
                    <span> 
                      {' '}
                      { signUpIsOn ? 'Sign up' : 'Log in'}
                    </span>
                  </button>
                </div>
              </>
            )}
            {newPasswordRequired && (
              <>
                <input
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Password"
                  type="password"
                />
                <input
                  value={newPasswordRepeat}
                  onChange={e => setNewPasswordRepeat(e.target.value)}
                  placeholder="Repeat password"
                  type="password"
                />
                <div className="error__wrapper">
                  <span className="error">{seconderrorToast}</span>
                </div>
                <div className="login-modal__window__submit__button">
                  <button
                    type="submit"
                    className="login-modal__window__form__submit"
                    onClick={firstLogin}
                  >
                    <span> 
                      { signUpIsOn ? 'Sign up' : 'Log in'}
                    </span>
                  </button>
                </div>
              
              </>
            )}
          </div>
        )}
        
      </div>
    </div>
  );
}

export default LoginModal;